import { useAppContext } from '@/context/AppContext';
import { isStuOpen } from '@/utils/stu/access';

/**
 * Whether this member may start a super top-up journey (`RETAIL_SUPER_TOP_UP`). Undefined until
 * `/me` has loaded, so the entry card never flashes and a start page waits instead of bouncing.
 */
export const useStuAccess = (): boolean | undefined => {
  const { userConfig, isAppLoading } = useAppContext();

  if (isAppLoading && !userConfig) return undefined;

  return isStuOpen(userConfig?.featureFlags);
};

export default useStuAccess;
